import { http } from '../http';

export interface Cooperativa {
  codigo_cooperativa: string;
  nome: string;
  valor_pagamento: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  cep: string;
  email: string;
  cpf: string;
  contato: string;
  telefone: string;
  valor_pagamento_residual: string;
  telefone_comercial: string;
  formato_pagamento_residual: string;
  formato_pagamento: string;
  situacao: string;
}

export interface CooperativaResponse {
  total: number;
  page: number;
  limit: number;
  items: Cooperativa[];
}

export const fetchSgaCooperativas = async (
  page: number = 1,
  limit: number = 10,
  busca?: string
): Promise<CooperativaResponse> => {
  const termo = busca && busca.trim() ? busca.trim() : undefined;
  const response = await http.get('/sga-cooperativa/listar', {
    params: { page, limit, ...(termo ? { busca: termo } : {}) },
  });

  return response.data;
};

/** Sincroniza o espelho de cooperativas com o SGA (TI/ADMIN, at-34). */
export const sincronizarSgaCooperativas = async (): Promise<{
  sincronizadas: number;
  inativadas: number;
}> => {
  const { data } = await http.get('/sga-cooperativa/sync');
  return data;
};
